import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../redux/axiosBaseQuery";
import { baseApi } from "../../redux/baseAPI";
import axios from "axios";
import { getBaseUrl } from "redux/utils";

export const pharmacyApi = baseApi.injectEndpoints({
  tagTypes: ["Pharmacy", "MyPharmacy"],
  endpoints: (builder) => ({
    fetchFrequentPharmacy: builder.query({
      query: () => {
        return {
          url: `/prescriptions/get_frequently_used_pharmacies.json.json`,
          method: "GET",
        };
      },
      //transformResponse: (response, loading, arg) => response.response.data,

      // preferCacheValue: false,
    }),
    fetchFavoritePharmacy: builder.query({
      query: (pid) => {
        return {
          url: `/patients/favorite_pharmacy_list.json.json?pid=${pid}`,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
            ...result?.response?.data?.map(({ id }) => ({
              type: "Pharmacy",
              id,
            })),
            { type: "Pharmacy", id: "LIST" },
          ]
          : [{ type: "Pharmacy", id: "LIST" }],
      // preferCacheValue: false,
    }),
    searchPharmacy: builder.mutation({
      query: (payload) => {
        return {
          url: `/prescriptions/ds_search_pharmacy.json`,
          method: "post",
          data: payload,
        };
      },
      preferCacheValue: false,
    }),

    addfavorite: builder.mutation({
      query: (payload) => {
        return {
          url: `/patients/add_favorite_pharmacy.json`,
          method: "post",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "Pharmacy" }],
    }),
    removeFavorite: builder.mutation({
      query: (payload) => {
        return {
          url: `/patients/remove_favorite_pharmacy.json`,
          method: "post",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "Pharmacy" }],
    }),
    pharmacySearchField: builder.query({
      query: (payload) => {
        return {
          url: `/utilities/get_pharmacy_search_fields.json`,
          method: "GET",
          data: payload,
        };
      },
      //preferCacheValue: false,
    }),
    changePatientPharmacy: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/patients/save_patient_pharmacy.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      invalidatesTags: [{ type: "Pharmacy" }],

      // transformResponse: (response, meta, arg) => response.response.data.current,
      //invalidatesTags: [{ type: "Medication" }],
    }),
    getMyFavPharmacy: builder.query({
      query: (pid) => {
        return {
          url: `/users/get_fav_pharmacy_list.json?pid=${pid}`,
          method: "GET",
        };
      },
      providesTags: ["MyPharmacy"],
    }),
    removeMyFavorite: builder.mutation({
      query: (payload) => {
        return {
          url: `/users/remove_fav_pharmacy.json`,
          method: "post",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "MyPharmacy" }],
    }),
    addMyfavorite: builder.mutation({
      query: (payload) => {
        return {
          url: `/users/add_fav_pharmacy.json`,
          method: "post",
          data: payload,
        };
      },
      invalidatesTags: [{ type: "MyPharmacy" }],
    }),
    
  }),
});
export const {
  useFetchFrequentPharmacyQuery,
  useFetchFavoritePharmacyQuery,
  useSearchPharmacyMutation,
  useAddfavoriteMutation,
  useRemoveFavoriteMutation,
  usePharmacySearchFieldQuery,
  useChangePatientPharmacyMutation,
  useGetMyFavPharmacyQuery,
  useRemoveMyFavoriteMutation,
  useAddMyfavoriteMutation
} = pharmacyApi;


export function getFrequentUsedPharmacy(patientId, practiceId) {
let api_url = getBaseUrl();
    return axios.get(
      `${api_url}/prescriptions/get_frequently_used_pharmacies.json.json`,
      {}
    );
  
}
